
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host(:focus) {
  outline: none;
}
:host(:focus) .slh-tab-item, :host(:focus):active:not([disabled]), :host(:focus)[active]:not([disabled]) {
  background-color: inherit !important;
  border-bottom: 2px solid var(--slh-color-neutral-shade-60, #62779F) !important;
  border-radius: 4px 4px 0 0 !important;
}

.slh-tab-item {
  display: inline-flex;
  align-items: center;
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xs-font-size, 14px);
  color: var(--slh-color-neutral-shade-60, #62779F);
  line-height: var(--slh-base-xxs-line-height, 24px);
  letter-spacing: 0.02em;
  font-style: normal;
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  padding-top: 16px;
  padding-right: 0;
  padding-bottom: 8px;
  padding-left: 0;
  background-color: inherit;
  text-decoration: none;
  box-sizing: border-box;
  border-bottom: 2px solid transparent;
  outline: none;
}
.slh-tab-item:hover {
  cursor: pointer;
  border-bottom: 2px solid inherit !important;
  color: var(--slh-color-neutral, #39455D);
}
.slh-tab-item:active:not([disabled]), .slh-tab-item[active]:not([disabled]) {
  color: var(--slh-color-neutral, #39455D);
  border: none;
  border-bottom: 2px solid var(--slh-color-primary, #3B87D4) !important;
  background-color: inherit;
}
.slh-tab-item:focus:not([disabled]) {
  background-color: inherit !important;
  color: var(--slh-color-primary, #3B87D4);
}
.slh-tab-item[disabled] {
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
}
.slh-tab-item ::slotted(.icon-wrapper) {
  fill: currentColor;
}

:host(:focus) .slh-tab-item, :host(:focus):active:not([disabled]), :host(:focus)[active]:not([disabled]) {
  color: var(--slh-color-primary, #3B87D4);
}

:host([disabled]) {
  cursor: not-allowed;
  pointer-events: none;
}

:host(:focus) {
  outline: none;
}

:host(:focus-visible) {
  outline: none;
}
:host(:focus-visible) a span::after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 4px;
  box-sizing: border-box;
}

:host span {
  position: relative;
  padding: 4px;
}
`;
